///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ActivityDTO } from '../../../services/project-socket/activity-dto.model';
import { EngineExceptionDTO, ProgressDTO } from '../../../generated/shared-types.model';
import { GtthHistoryService } from '../../logical-topology/engine/history-service';

export class GtthProgressWindowModel {
    static readonly AUTO_DESIGN = 'GtthAutoDesignCommand';
    static readonly MULTIPLE_DESIGN = 'GtthMultipleAutoDesignCommand';
    static readonly SELECT_PRODUCTS = 'GtthAutoSelectProductsCommand';
    static readonly DESIGN_PTMP = 'GtthDesignPtMPCommand';
    static readonly AUTO_CONNECT = 'GtthAutoConnectCommand';
    static readonly HOUSE_DETECTION = 'GtthHouseDetectionCommand';
    static readonly ABORT_DESIGN = 'GtthAbortDesignCommand';
    static readonly DESIGN_RINGS = 'GtthDesignRingsCommand';
    static readonly AUTO_SET_FREQUENCIES = 'GtthAutoSetFrequenciesCommand';
    static readonly AUTO_CONFIG_RINGS = 'GtthAutoConfigureRingsCommand';

    constructor(
        public commandName: string,
        private readonly successful = false,
        private readonly finished = false,
        private readonly interrupted = false,
        public error?: EngineExceptionDTO,
        public progress?: ProgressDTO,
        public iterationNumber?: number,
        public preloaderText?: string
    ) {}

    static create(commandName: string): GtthProgressWindowModel {
        return new GtthProgressWindowModel(commandName, true, false, false);
    }

    static createFromActivityDTO(activityDto: ActivityDTO): GtthProgressWindowModel {
        return new GtthProgressWindowModel(
            activityDto.commandName,
            activityDto.successful,
            activityDto.progress?.finished || false,
            activityDto.interrupted,
            activityDto.error,
            activityDto.progress,
            activityDto.designIterationNumber || 0
        );
    }

    static createMultipleFromHistory(historyService: GtthHistoryService): GtthProgressWindowModel {
        return new GtthProgressWindowModel(this.MULTIPLE_DESIGN, true, true, false, undefined, {
            percent: 100,
            designIterationsChartData: historyService.logicalTopology.designIterationsChartData,
            finished: undefined,
            stepName: undefined
        });
    }

    public isCommandFinished(): boolean {
        return this.finished || this.interrupted;
    }

    public isInterrupted(): boolean {
        return this.interrupted;
    }

    public isSuccessfull(): boolean {
        return this.successful;
    }
}
